import {Outlook, OutlookInfo} from '../services/api/fit-api/models/indicators/outlook-info';
import {OutlookConfig, OUTLOOKS} from './outlook.config';

/**
 *  This model is used to drive the outlook indicator display
 *
 *  Either the Outlook text or the count can be displayed.
 */
export class OutlookIndicator extends OutlookInfo {
	public outlookConfig?: OutlookConfig;

	constructor(
		outlook: Outlook,
		annotation?: string | null,
		public count?: number,
		public aggregate?: string,
		public stacked?: boolean
	) {
		super(outlook, annotation);
		this.outlookConfig = OUTLOOKS.find(o => o.outlook === outlook);
	}

	// Needed as the string value of the outlook will be used in searches, etc.  Also, the text generated can be used
	// in building narrative text for tooltips and other text-based explanations
	override toString = () => this.outlook?.toString() ?? '';

	/**
	 * Generic method to return outlook indicator based on array of outlooks
	 * @param outlooks
	 * @param stacked
	 */
	static aggregate = (outlooks?: Array<OutlookInfo | undefined>, stacked?: boolean): OutlookIndicator => {
		if (outlooks?.some((outlookInfo?: OutlookInfo) => outlookInfo?.outlook === 'Concerning')) {
			return new OutlookIndicator('Concerning', 'One or more indicators have an outlook that is concerning. More information about outlooks can be found in FIT’s main Help tab.', undefined, 'At least one Concerning Indicator', stacked);
		} else if (outlooks?.some((outlookInfo?: OutlookInfo) => outlookInfo?.outlook === 'Cautionary')) {
			return new OutlookIndicator('Cautionary', 'One or more indicators have an outlook that is cautionary. More information about outlooks can be found in FIT’s main Help tab.', undefined, 'At least one Cautionary Indicator', stacked);
		} else if (outlooks?.some((outlookInfo?: OutlookInfo) => outlookInfo?.outlook === 'Good')) {
			return new OutlookIndicator('Good', 'All indicators with benchmarks have a good outlook. More information about outlooks can be found in FIT’s main Help tab.', undefined, 'Good');
		} else {
			return new OutlookIndicator('Indeterminate', 'Not enough information available to make a determination.', undefined, 'Indeterminate');
		}
	}

}
